import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ApplyTagDialog } from 'app/field-shared/dialogs/apply-tag/apply-tag.dialog';
import { getFieldTypeIcon } from 'app/field-shared/field-helper-functions';

import {
  CalendarEventResponseCoreFragment,
  EntityConnectionWithTagsFragment, EntityWithTagsFragment, Maybe, TagCategoryInfoFragment
} from 'generated/graphql';

@Component({
  selector: 'app-applied-tag-category-table',
  templateUrl: './applied-tag-category-table.component.html',
  styleUrls: ['./applied-tag-category-table.component.scss']
})
export class AppliedTagCategoryTableComponent  {
  @Input() category: TagCategoryInfoFragment & { readonly?: boolean } ;
  @Input() target: EntityWithTagsFragment | EntityConnectionWithTagsFragment | CalendarEventResponseCoreFragment;
  @Input() campaignId: string;
  @Input() showTaskDoneMark: boolean;

  /**
   * Number of tags which should be shown initially
   */
  @Input() initialTagsVisible = 3;

  get appliedTagsForCategory() {
    // If target is a CalendarEventResponse, use appliedTags instead of tags
    if (this.target.__typename === 'CalendarEventResponse') {
      return this.target.appliedTags?.filter(
        t => t.tag?.category?.id === this.category.id
      ).filter(
        t => t.deleted === false
      );
    }
    return this.target.tags?.filter(
      t => t.tag?.category?.id === this.category.id
    ).filter(
      t => t.deleted === false
    );
  }

  get initiallyVisibleTags() {
    return this.appliedTagsForCategory.slice(0, this.initialTagsVisible);
  }

  get hasAppliedTags() {
    return this.appliedTagsForCategory.length > 0;
  }

  showAll = false;

  constructor(
    private _dialog: MatDialog
  ) { }


  addTagClicked(category: TagCategoryInfoFragment) {
    ApplyTagDialog.open(this._dialog, {
      data: {
        category,
        targetType: this.target.__typename || 'Entity',
        targetId: this.target.id,
        campaignId: this.campaignId // this.target.campaignContextId
      }
    });
  }

  getTagTypeIcon(category: TagCategoryInfoFragment) {
    return getFieldTypeIcon(category);
  }
}
